import { truncate } from 'lodash';
import React from 'react';
import HelperTooltip from '../HelperTooltip';

export const TextEllipsis = ({ maxlength, content }: { maxlength: number; content: string }) => {
  const displayContent = truncate(content, { length: maxlength });
  return (
    <HelperTooltip disable={content.length <= maxlength} title={content}>
      <span>{displayContent}</span>
    </HelperTooltip>
  );
};
